import { render, staticRenderFns } from "./TikTokUnauthorisedProfileSearch.vue?vue&type=template&id=0fa3aeb5&scoped=true"
import script from "./TikTokUnauthorisedProfileSearch.vue?vue&type=script&lang=js"
export * from "./TikTokUnauthorisedProfileSearch.vue?vue&type=script&lang=js"
import style0 from "./TikTokUnauthorisedProfileSearch.vue?vue&type=style&index=0&id=0fa3aeb5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa3aeb5",
  null
  
)

export default component.exports